import { gql, useQuery } from "@apollo/client";
import { addDuration, formatDate } from "../../../../../utils/calendarUtils";
import { useSession } from "../../../../Atoms/AppSession";
import Loader from "../../../../Atoms/Loader";

export default function AvailableTomorrow({ productId }) {
  const session = useSession();
  const { countryCode } = session;
  const now = new Date();
  const until = addDuration(now, { days: 1 });

  const { loading, error, data } = useQuery(GET_AVAILABILITY, {
    fetchPolicy: "cache-and-network",
    ssr: false,
    variables: {
      productId: productId,
      fromDate: formatDate(now),
      untilDate: formatDate(until),
    },
    skip: countryCode !== "Asia/Tokyo",
  });

  if (loading && countryCode === "Asia/Tokyo") {
    return <Loader />;
  }

  if (error || !data) {
    return <></>;
  }
  const {
    product: { availability },
  } = data;

  const isProductAvailableToday = availability.find(
    (f) => f.status === "AVAILABLE" && f.date === formatDate(now)
  );

  const isProductAvailableTomorrow = availability.find(
    (f) => f.status === "AVAILABLE" && f.date === formatDate(until)
  );

  return (
    <>
      {countryCode === "Asia/Tokyo" && isProductAvailableToday && (
        <p
          style={{
            padding: 3,
            borderRadius: 5,
            textAlign: "center",
            fontWeight: "bold",
            fontSize: 11,
            background: "#28B493",
            color: "#fff",
            maxWidth: 180,
          }}
        >
          Available Today
        </p>
      )}
      {!isProductAvailableToday &&
        countryCode === "Asia/Tokyo" &&
        isProductAvailableTomorrow && (
          <p
            style={{
              padding: 3,
              borderRadius: 5,
              textAlign: "center",
              fontWeight: "bold",
              fontSize: 11,
              background: "#28B493",
              color: "#fff",
              maxWidth: 180,
            }}
          >
            Available Tomorrow
          </p>
        )}
    </>
  );
}

const GET_AVAILABILITY = gql`
  query AvailabilityQuery(
    $productId: ID!
    $fromDate: Date!
    $untilDate: Date!
  ) {
    product(id: $productId) {
      availability(fromDate: $fromDate, untilDate: $untilDate) {
        date
        status
      }
    }
  }
`;
